<template>
    <div class="d-flex">
        <div v-if="loading === true" style="width:10rem;height:10rem;"><b-spinner style="width: 3rem; height: 3rem;"
                variant="primary" label="Large Spinner"></b-spinner></div>
        <div style="width:100%" v-if="loading === false">
            <H1>Home</H1>
            <div style="padding-top:30px;">
                <div class="card">
                    <div class="card-header">
                        <h2>My Profile</h2>
                    </div>
                    <div class="card-body">
                        <div class="container">
                            <div class="row">
                                <div class="col d-flex flex-column mb-3">
                                    <div class="p-0"><span>{{ this.profileDetails.firstName }}
                                            {{ this.profileDetails.lastName }}</span></div>
                                    <div class="p-0"><span>{{ this.profileDetails.organizationName }} </span></div>
                                    <div class="p-0"><span>{{ this.profileDetails.address }} </span></div>
                                    <div class="p-0"><span>{{ this.profileDetails.address1 }} </span></div>
                                    <div class="p-0"><span>{{ this.profileDetails.city }}, {{ this.profileDetails.state }}
                                            {{
                                                this.profileDetails.postal }} </span></div>

                                </div>
                                <div class="col d-flex flex-column mb-3">
                                    <div class="p-0"><span>{{ this.profileDetails.phoneNumber }} </span></div>
                                    <div class="p-0"><span>{{ this.profileDetails.email }} </span></div>
                                </div>
                                <div class="col d-flex flex-column mb-3">
                                    <div class='p-2'><b-button variant="primary" v-on:click="editProfile">
                                            Edit Profile</b-button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding-top: 30px;">
                <div class="card">
                    <div class="card-header">
                        <h2>Transactions</h2>
                    </div>
                    <div id="createTransaction"> <b-button variant="primary" v-on:click="createTransaction">
                            Create Transaction</b-button> </div>

                    <div>
                        <b-card no-body>
                            <b-tabs content-class="mt-2" lazy>
                                <b-tab title="Active">
                                    <div>
                                        <b-table striped hover :items="activeTransactionsList" :fields="fields">
                                            <template v-slot:cell(edit)="data">
                                                <router-link :to="{
                                                    name: 'hceteditransaction',
                                                    params: { id: data.item.transactionId }
                                                }" tag="button" class="btn btn-primary">Edit
                                                </router-link>
                                            </template>
                                        </b-table>
                                    </div>
                                </b-tab>
                                <b-tab title="Completed">
                                    <div>
                                        <b-table striped hover :items="completedTransactionsList" :fields="fields">
                                        </b-table>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
#createTransaction {
    padding-top: 25px;
    padding-bottom: 25px;
    padding-left: 25px;
}

li {
    list-style-type: none;
    margin: 0;
}

.card-header {
    background-color: #003865;
    color: #FFF;
}

.hcx-hide {
    text-indent: -1000em;
}
</style>
<script>
import lambdaURL from '../../lambdahcetx'
import router from '../../router';

export default {
    async mounted() {
        try {
            this.loading = true;
            const contactResponse = await lambdaURL.getHceTxContact(this.$keycloak.userName);
            localStorage.setItem("contactId", contactResponse.contactId);
            this.profileDetails = {
                contactId: contactResponse.contactId,
                firstName: contactResponse.firstName,
                lastName: contactResponse.lastName,
                organizationName: contactResponse.organizationName,
                address: contactResponse.address1,
                address1: contactResponse.address2,
                city: contactResponse.city,
                state: contactResponse.stateProvince,
                postal: contactResponse.zip,
                phoneNumber: contactResponse.phone,
                email: contactResponse.email
            }
            if (this.profileDetails.phoneNumber) {
                const unFormattedPhoneNumber = this.profileDetails.phoneNumber;
                var cleaned = ('' + unFormattedPhoneNumber).replace(/\D/g, '');
                var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                    this.profileDetails.phoneNumber = '(' + match[1] + ') ' + match[2] + '-' + match[3];
                }
            }
            const translationsContactSummaryResponse = await lambdaURL.getHceTxTransactionContactSummary(this.profileDetails.contactId);
            this.activeTransactionsList = translationsContactSummaryResponse.filter((item) => {

                if (item.activeInd) {
                    return item;
                }
            }).map(item => {
                const transactionItem = {
                    transactionId: item.transactionId,
                    transactionTitle: item.transactionTitle,
                    transactionTypeDesc: item.transactionTypeDesc,
                    proposedCompletionDate: item.proposedCompletionDate,
                    dueDate: item.dueDate,
                    transactionStatusDesc: item.transactionStatusDesc,
                    createUser: item.createUser,
                    createDate: item.createDate,
                    updateUser: item.updateUser,
                    updateDate: item.updateDate
                }
                return transactionItem;
            });
            this.completedTransactionsList = translationsContactSummaryResponse.filter((item) => {
                if (!item.activeInd) {
                    return item;
                }
            }).map(item => {
                const transactionItem = {
                    transactionId: item.transactionId,
                    transactionTitle: item.transactionTitle,
                    transactionTypeDesc: item.transactionTypeDesc,
                    proposedCompletionDate: item.proposedCompletionDate,
                    dueDate: item.dueDate,
                    transactionStatusDesc: item.transactionStatusDesc,
                    createUser: item.createUser,
                    createDate: item.createDate,
                    updateUser: item.updateUser,
                    updateDate: item.updateDate
                }
                return transactionItem;
            });
        } finally {
            this.loading = false;
        }

    },
    data() {
        return {
            loading: 'false',
            fields: [{ key: 'Edit', thClass: 'hcx-hide' }, { key: 'transactionId', sortable: true }, 'transactionTitle', { key: 'transactionTypeDesc', label: 'Transaction Type' }, { key: 'proposedCompletionDate', sortable: false }, { key: 'dueDate', sortable: true }, { key: 'transactionStatusDesc', label: 'Transaction Status' }, 'createUser', { key: 'createDate', sortable: true }, 'updateUser', { key: 'updateDate', sortable: false }],
            profileDetails: {
                contactId: '',
                email: '',
                firstName: '',
                lastName: '',
                organizationName: '',
                address: '',
                address1: '',
                city: '',
                state: '',
                postal: '',
                phoneNumber: ''
            },
            activeTransactionsList: [{
                transactionId: '',
                transactionTitle: '',
                transactionTypeDesc: '',
                proposedCompletionDate: '',
                dueDate: '',
                transactionStatusDesc: '',
                createUser: '',
                createDate: '',
                updateUser: '',
                updateDate: ''
            }],
            completedTransactionsList: [{
                transactionId: '',
                transactionTitle: '',
                transactionTypeDesc: '',
                proposedCompletionDate: '',
                dueDate: '',
                transactionStatusDesc: '',
                createUser: '',
                createDate: '',
                updateUser: '',
                updateDate: ''
            }]
        }
    },
    methods: {
        editProfile: function () {
            router.push("/hce/editprofile/" + this.$keycloak.userName);
        },
        createTransaction: function () {
            sessionStorage.removeItem("transactionId"); //Transaction page load cleaning existing transaction.
            router.push("/hce/createtransactions");
        },

    }
}
</script>
